const { $ } = window;

$(() => {
  $('#scroll-to-top').on('click', () => {
    $('body, html').animate({ scrollTop: 0 }, () => {
      $('body').trigger('scrolled-to-top');
    });
  });
});
